export type Service = {
  activity?: string;
  code?: string;
  description?: string;
  factor?: string | number;
  id?: string;
  price?: string | number;
  quantity?: string | number;
  unid?: string;
  _key?: string; // internal key when converting object to array
};

const omitKey = (s: Service) => {
  const { _key, ...rest } = s as any;
  return rest as Service;
};

export const normalizeServices = (services: any): Service[] => {
  if (!services) return [];
  if (Array.isArray(services))
    return services.map((s) => ({ ...s }) as Service);

  return Object.entries(services).map(([key, val]) => ({
    ...(val as Service),
    _key: key,
  }));
};

export const servicesToSaveShape = (
  servicesArray: Service[],
  originalServices: any,
): any => {
  if (Array.isArray(originalServices)) {
    // keep array shape
    return servicesArray.map(omitKey);
  }

  // original is an object keyed by ids. preserve existing keys when present,
  // assign new numeric keys for items without _key.
  const originalKeys = Object.keys(originalServices || {});
  const numericKeys = originalKeys
    .map((k) => Number(k))
    .filter((n) => !isNaN(n));
  let maxKey = numericKeys.length ? Math.max(...numericKeys) : 0;

  const out: Record<string, Service> = {};

  servicesArray.forEach((s) => {
    if (s._key) {
      out[s._key] = omitKey(s);
    } else {
      maxKey++;
      out[String(maxKey)] = omitKey(s);
    }
  });

  return out;
};
